import { SET_CATERING_SUBCAT } from "../actions";

const subcategorylist = (state = [], action) => {
  switch (action.type) {
    case SET_CATERING_SUBCAT:
      return [...action.value];
    default:
      return state;
  }
};

export default subcategorylist;
